/** @format */
import {
  FETCH_ORGS_REQUEST,
  FETCH_ORGS_SUCCESS,
  FETCH_ORGS_FAILURE,
} from "./SearchTypes.js";

const initialState = {
  loading: false,
  orgData: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ORGS_SUCCESS:
      return {
        loading: false,
        orgData: action.payload,
        error: "",
      };
    case FETCH_ORGS_FAILURE:
      return {
        loading: false,
        orgData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
